import { useMemo } from "react";
import type { ReactNode } from "react";
import { I18nextProvider } from "react-i18next";
import { i18n } from "@/i18n";

/** Admin chrome is English whatever `user.locale` says. A clone of the app instance with `lng: "en"`
 * shares its resources, so every `useTranslation` below this provider reads English while the product
 * bundle (the original instance) keeps the user's language. */
export function AdminI18n({ children }: { children: ReactNode }): JSX.Element {
  const adminI18n = useMemo(() => i18n.cloneInstance({ lng: "en" }), []);
  return <I18nextProvider i18n={adminI18n}>{children}</I18nextProvider>;
}
